import { HandHeartIcon } from './HandHeartIcon';

/**
 * author: Google
 * id 5B605565-DBBC-4141-8B07-D8009B74D4E1
 * name hand-heart
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-heart.svg
 * tags
 */
export const VolunteerIcon = HandHeartIcon;
export default VolunteerIcon